import { useTranslation } from 'react-i18next';
import type { PartyStatus } from '@/shared/types/api/parcels';
import { StatusChip } from '@/shared/ui/chips/StatusChip';

type PartyStatusChipProps = {
  status: PartyStatus;
  className?: string;
};

const PARTY_STATUS_STYLES: Record<PartyStatus, string> = {
  COLLECTING: 'bg-slate-100 text-slate-700 border-slate-200',
  SHIPPING: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  ON_THE_WAY: 'bg-sky-100 text-sky-800 border-sky-200',
  ON_CUSTOMS: 'bg-amber-100 text-amber-800 border-amber-200',
  LOCAL_ON_THE_WAY: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  SHIPMENT_ON_CUSTOMERS: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export const PartyStatusChip = ({ status, className }: PartyStatusChipProps) => {
  const { t } = useTranslation('partyStatus');
  return (
    <StatusChip toneClass={PARTY_STATUS_STYLES[status]} label={t(status)} className={className} />
  );
};
